import { useLanguage } from "@/contexts/LanguageContext";
import { Home, GraduationCap, Construction } from "lucide-react";

const AboutPage = () => {
  const { t, language } = useLanguage();

  return (
    <div className="pt-16">
      <div className="bg-secondary">
        <div className="container mx-auto py-16 px-4 md:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {t("about.title")}
          </h1>
          <p className="text-xl text-primary">{t("about.subtitle")}</p>
        </div>
      </div>

      <div className="container mx-auto py-12 px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="text-2xl font-bold mb-4">
              {t("about.history.title")}
            </h2>
            <p className="mb-6">{t("about.history.early")}</p>
            <p className="mb-6">{t("about.history.turning")}</p>
          </div>
          <div className="space-y-6">
            <img
              src="/lovable-uploads/3d96a73f-1b69-442f-bffc-fb7b6cce50da.png"
              alt={t("about.photo.bike.alt")}
              className="w-full h-auto rounded-lg shadow-md"
            />
            <p className="text-sm text-muted-foreground text-center">
              {t("about.photo.bike")}
            </p>
          </div>
        </div>

        <div className="my-12">
          <h2 className="text-2xl font-bold mb-4">Angels of East Africa</h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="mb-6">{t("about.angels.description")}</p>
              <p className="mb-6">{t("about.angels.work")}</p>
            </div>
            <div>
              <img
                src="/lovable-uploads/6c8f0efb-816b-492f-8627-59724eac2d01.png"
                alt={t("about.photo.children.alt")}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="my-12">
          <h2 className="text-2xl font-bold mb-4">{t("about.movie.title")}</h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="aspect-video">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/47yl-ySEw3A"
                title={t("about.movie.trailer.title")}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg shadow-md"
              />
            </div>
            <div>
              <p className="mb-6">{t("about.movie.description")}</p>
              <p>{t("about.movie.details")}</p>
            </div>
          </div>
        </div>

        <div className="my-12">
          <h2 className="text-2xl font-bold mb-6">
            {t("about.activities.title")}
          </h2>
          <p className="text-lg mb-8">{t("about.activities.intro")}</p>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-card p-6 rounded-lg shadow-sm border border-border">
              <div className="flex items-center gap-3 mb-4">
                <Home className="h-6 w-6 text-primary" />
                <h3 className="text-xl font-bold">
                  {t("about.activities.orphanages.title")}
                </h3>
              </div>
              <p>{t("about.activities.orphanages.description")}</p>
            </div>
            <div className="bg-card p-6 rounded-lg shadow-sm border border-border">
              <div className="flex items-center gap-3 mb-4">
                <GraduationCap className="h-6 w-6 text-primary" />
                <h3 className="text-xl font-bold">
                  {t("about.activities.schools.title")}
                </h3>
              </div>
              <p>{t("about.activities.schools.description")}</p>
            </div>
            <div className="bg-card p-6 rounded-lg shadow-sm border border-border">
              <div className="flex items-center gap-3 mb-4">
                <Construction className="h-6 w-6 text-primary" />
                <h3 className="text-xl font-bold">
                  {t("about.activities.infrastructure.title")}
                </h3>
              </div>
              <p>{t("about.activities.infrastructure.description")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
